<div>
    <mat-form-field class="full-width">
        <mat-label>Wildcard</mat-label>
        <input matInput
               type="text"
               name="deviceFilter"
               [class.text-color-white]="isDarkTheme()"
               [value]="detailViewService.filter.wildcard"
               [formControl]="deviceFilterFormControl" />
    </mat-form-field>
    <mat-form-field class="full-width"
                    *ngIf="!hideFields">
        <mat-label>Job Number</mat-label>
        <input matInput
               type="number"
               name="jobNumber"
               [class.text-color-white]="isDarkTheme()"
               [value]="detailViewService.query.jobNumber"
               (keyup.enter)="onGetDetail()"
               [formControl]="jobNumberFormControl" />
    </mat-form-field>
    <advanced-dropdown *ngIf="!hideFields && filters.locations.visible"
                       class="caslink"
                       [data]="filters.locations"
                       [(model)]="detailViewService.query.locationId"
                       (change)="filters.locationHandler()"
                       [itemHeight]="35"
                       [width]="226">
    </advanced-dropdown>
    <advanced-dropdown *ngIf="!hideFields"
                       class="caslink"
                       [data]="filters.modules"
                       [(model)]="detailViewService.query.moduleId"
                       (change)="onGetDetail()"
                       [itemHeight]="35"
                       [width]="226"></advanced-dropdown>
    <advanced-dropdown class="caslink"
                       [data]="filters.categories"
                       [(model)]="detailViewService.filter.categoryId"
                       (change)="categoryHandler($event)"
                       [itemHeight]="35"
                       [width]="226"></advanced-dropdown>
    <cas-button [btnText]="'Toggle Reader View'" (clickAction)="onToggleReaderView()" class="filter-buttons"></cas-button>
    <cas-button [btnText]="'Clear Filters'" *ngIf="!hideFields" (clickAction)="clearFilters()" class="filter-buttons"></cas-button>
</div>
